import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
export default function MobileNavigation() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeMenu, setActiveMenu] = useState(window.location.pathname); 
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setIsLoggedIn(document.body.classList.contains("isLoggedIn"));
  }, []);

  const navItems = [
    {
      id: 1,
      img: "/images/icons/carousel.png",
      alt: "Online Slot",
      navp: `${t('nav.10')}`,
      href: "/live-casino/",
      hidden: false,
      className: "slot-mobile-nav",
    },
    {
      id: 2,
      img: "/images/icons/slot.png",
      alt: "Slot",
      navp: `${t('nav.1')}`,
      href: "/slots/pgsoft/",
      hidden: false,
      className: "live-mobile-nav",
    },
    {
      id: 3,
      img: "/images/icons/sports.png",
      alt: "Sportsbook",
      navp: `${t('nav.12')}`,
      href: "/sportsbook/",
      hidden: false,
      className: "calumpit-filter",
    },
     {
      id: 5,
      img: "/images/icons/race.png",
      alt: "Hot Deals Promotions",
      navp: "PK10",
      href: "/pk10-keno/",
      hidden: false,
      className: "promo-mobile-nav",
    },
    {
      id: 4,
      img: "/images/promo-mobile-icon.webp",
      alt: "Hot Deals Promotions",
      navp: `${t('nav.13')}`,
      href: "/promotion/",
      hidden: false,
      className: "promo-mobile-nav",
    },
    {
      id: 6,
      img: "/images/recent-games-mobile-icon.webp",
      alt: "Recent Games",
      span: "Games",
      navp: `${t('nav.14')}`,
      href: "/account/dashboard/",
      hidden: true,
      className: "recent-mobile-nav",
    },
  ];

  const listItems = navItems.map((data) => {
    if (data.hidden === true && !isLoggedIn) {
      return null; // Don't render this item if the user is not logged in
    }
    return (
      <li
        key={data.id}
        className={`${data.className} ${activeMenu === `${data.href}` ? 'active' : ''}`}
      >
        <a
          href={data.href}
          className={`mobileNav nav-link-${data.navp.toLowerCase()}`}
        >
          <img src={data.img} alt={data.alt} />
          <p>{data.navp}</p>
        </a>
      </li>
    );
  });

  return (
    <section className="mobileFooterNav">
      <ul>{listItems}</ul>
    </section>
  );
}
